'use client';

import { useCatalogContext } from '@dealerportal/catalog-ui/Contexts/CatalogContext';
import classNames from 'classnames';
import type { FC } from 'react';
import { FavouritesCount } from './FavouritesCount';
import { FilterToggle } from './FilterToggle';
import { SortPopover } from './SortPopover';

// Combined component with updated button styling
export const ProductToolbar: FC = () => {
  const {
    filtersVisible,
    setFiltersVisible,
    tags,
    hasPricing,
    updateSort,
    useCiC,
  } = useCatalogContext();

  return (
    <div className="ui-flex ui-items-center ui-border ui-border-solid ui-rounded-md ui-border-gray-300">
      {/* Filter Button */}
      <FilterToggle
        filtersVisible={filtersVisible ?? true}
        toggleFilters={() => setFiltersVisible(!filtersVisible)}
        className="ui-flex-grow ui-bg-white ui-border-0 ui-rounded-l-md"
      />

      {/* Sorting Button */}
      {!useCiC && (
        <SortPopover
          onSortChange={updateSort}
          tags={tags}
          hasPricing={hasPricing}
          className="ui-bg-white ui-border-0 ui-border-l ui-border-r ui-border-solid ui-border-gray-300"
        />
      )}

      {/* Favorites Button */}
      <FavouritesCount
        className={classNames({
          'ui-bg-white ui-border-0 ui-border-l ui-rounded-l-none !ui-border-gray-300':
            useCiC,
          'ui-bg-white ui-border-none ui-rounded-l-none ui-rounded-r-md':
            !useCiC,
        })}
        labelClassName="ui-text-sm ui-font-medium"
        iconClassName="ui-text-red-600"
      />
    </div>
  );
};
